import { fr, en } from './translations'

export const Brands = {
  MtnCameroonBLG: 'mtn-cm-blg'
}

export const Languages = {
  French: 'fr',
  English: 'en'
}

// Theme: each key becomes a CSS variable on the app root (colorBg -> --color-bg). Anything omitted
// falls back to the defaults in assets/css/main.css. Dark arena ground with MTN's yellow as the
// single accent, so the page reads as MTN-native on the subscriber's phone.
const blgTheme = {
  colorBg: '#0b0e17',
  colorSurface: '#141927',
  colorSurfaceRaised: '#1a2033',
  colorSurfaceBorder: '#262e45',
  colorPrimary: '#ffcb05',
  colorPrimaryDark: '#e6b600',
  colorOnPrimary: '#0b0e17',
  colorAccent: '#ffd84d',
  colorText: '#f4f6fb',
  colorTextSecondary: '#9ba4ba',
  colorError: '#ff6b6b',
  colorSuccess: '#3ddc97',
  fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  fontDisplay: "'Rajdhani', 'Inter', sans-serif"
}

export const brandConfigs = {
  [Brands.MtnCameroonBLG]: {
    brand: Brands.MtnCameroonBLG,
    language: Languages.French,
    languages: [Languages.French, Languages.English],
    isRTL: false,

    // Identity: the operator/market this LP recruits for and what the subscriber sees it called.
    carrier: 'MTN',
    country: 'CM',
    currency: 'XAF',
    serviceName: 'Battle League Gaming',
    serviceTag: 'battle-league-gaming',

    // Product: Penrose enterprise ids the MADAPI service keys on (svc_Service 252 MADAPI_BLG_CM) plus
    // the MTN plan id (prd_Products.ExternalProductId) per tier. OPS-655 / DB-424.
    serviceId: 252,
    productId: 616,
    networkServiceId: 'P_Penro_Battl_6080',
    prices: [
      { period: 'day', labelKey: 'planDaily', periodKey: 'perDay', amount: 150, productId: 616, networkServiceId: 'P_Penro_Battl_6080' },
      { period: 'week', labelKey: 'planWeekly', periodKey: 'perWeek', amount: 500, productId: 705, networkServiceId: 'P_Penro_Battl_6085' },
      { period: 'month', labelKey: 'planMonthly', periodKey: 'perMonth', amount: 1200, productId: 706, networkServiceId: 'P_Penro_Battl_6086' }
    ],
    // Days free before the first charge (OPS-988: 1 day trial).
    trialDays: 1,
    registrationChannel: 'WEB',

    // MSISDN rules for the manual input: Cameroon numbers are 9 digits after +237 with no trunk
    // prefix; MTN ranges are 650-654, 67X and 68X.
    msisdn: { countryCode: '237', trunkPrefix: '', localLength: 9, localPrefixes: ['650', '651', '652', '653', '654', '67', '68'] },

    // Links + assets: portal hand-off after subscribing (?msisdn= appended), terms, artwork in /public/assets.
    // TODO(Commercial): confirm the production portal and T&Cs URLs before go-live.
    portalUrl: 'https://cm-mtn.blg.gg/',
    termsConditionsUrl: 'https://cm-mtn.blg.gg/terms-conditions',
    // The DES-1285 banner carries the BLG wordmark itself, so no separate logo is overlaid on it.
    bannerImage: '/assets/blg-banner.webp',
    logoImage: '/assets/blg-logo.png',
    showLogoOverlay: false,

    // Evina DCBprotect: the protected element the kit binds to, and whether a kit that failed to load
    // blocks the subscribe (false = fail open, the subscribe proceeds and the service logs it).
    evina: { targetElement: '#subscribe_button', required: false },

    theme: blgTheme,
    translations: { fr, en }
  }
}
